var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.9302 77.8604C60.4308 77.8604 77.8604 60.4308 77.8604 38.9302C77.8604 17.4296 60.4308 0 38.9302 0C17.4296 0 0 17.4296 0 38.9302C0 60.4308 17.4296 77.8604 38.9302 77.8604Z",
    fill: "#DB004F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.7 20H57.3C59.885 20 62 22.0812 62 24.625V52.375C62 54.9188 59.885 57 57.3 57H19.7C17.115 57 15 54.9188 15 52.375V24.625C15 22.0812 17.115 20 19.7 20Z",
    fill: "#DB004F",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 25L38.5 41L15 25",
    fill: "#DB004F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 25L38.5 41L15 25",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.1046eb31e2343da1da437b24b504154f.svg";
export { ForwardRef as ReactComponent };